import { DataModelAttribute } from '@/types/DataModel';

import { AddItemDialog,CreateNewItemDialog } from '../dialogs';
import { ReferenceItemOption } from '../types';

interface MultiReferenceDialogsProps {
    isDialogOpen: boolean;
    isCreateNewItemDialogOpen: boolean;
    onDialogOpenChange: (open: boolean) => void;
    onCreateNewItemDialogOpenChange: (open: boolean) => void;
    attribute: DataModelAttribute;
    readonly: boolean;
    placeholder: string;
    requiredAttributes: DataModelAttribute[];
    onItemAdded: (item: ReferenceItemOption) => void;
    onItemCreated: (item: ReferenceItemOption) => void;
    newlyCreatedItem: ReferenceItemOption | null;
}

export const MultiReferenceDialogs = ({
    isDialogOpen,
    isCreateNewItemDialogOpen,
    onDialogOpenChange,
    onCreateNewItemDialogOpenChange,
    attribute,
    readonly,
    placeholder,
    requiredAttributes,
    onItemAdded,
    onItemCreated,
    newlyCreatedItem
}: MultiReferenceDialogsProps) => {
    return (
        <>
            <AddItemDialog
                isOpen={isDialogOpen}
                onOpenChange={onDialogOpenChange}
                attribute={attribute}
                readonly={readonly}
                placeholder={placeholder}
                requiredAttributes={requiredAttributes}
                onItemAdded={onItemAdded}
                preselectedItem={newlyCreatedItem}
            />

            <CreateNewItemDialog
                isOpen={isCreateNewItemDialogOpen}
                onOpenChange={onCreateNewItemDialogOpenChange}
                onItemCreated={onItemCreated}
                attribute={attribute}
            />
        </>
    );
};

